module.exports = __webpack_public_path__ + "2c3c9a9a3a32bc8e02b249946db7be6f.svg";